import React, {Component} from 'react';
import "./Error.css";
import errorImg from "../../images/404.png";
import 'bootstrap/dist/css/bootstrap.css';
import {Button} from "react-bootstrap";

class Error extends Component {
    constructor(props) {
        super(props);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        window.location.href = '/';
    }

    render() {
        return (<div className="container-fluid row containerStyl">
                <div className="errorBodyStyl">
                    <img src={errorImg} className='errorImg' alt={"error"}/>
                    <h2 className='oops'>404 Route Not Found !!!</h2>
                    <h5 className='text-muted' style={{textAlign: 'center'}}>Something went wrong. Please check the
                        endpoint url.</h5>
                    <div className='buttondiv'>
                        <Button type="button" onClick={this.handleSubmit}
                                className="errorSubmit">
                            Go Back
                        </Button>
                    </div>
                </div>
            </div>);
    }
}

export default Error;
